<!-- Error alert -->
@if (hasCustomErrors && pristine === false) {
  <ngb-alert class="modal-footer__warning" [dismissible]="false" type="danger">
    <portal-validation-errors [dirty]="isPristine === false" [errors]="errors"></portal-validation-errors>
  </ngb-alert>
}

<!-- Pending alert -->
@if (pending) {
  <ngb-alert class="modal-footer__warning" [dismissible]="false" type="info">
    {{ 'general.form.pendingValidation' | translate }}
  </ngb-alert>
}

<!-- Modal Footer -->
<div class="modal-footer">
  <!-- Cancel -->
  <button class="btn btn-link" (click)="emitCancel()" type="button">
    <i class="far fa-times fa-fw"></i>
    <ng-container *portalTransclusion="transclusions; name: 'cancel'"
      >{{ (closeOnly ? 'button.close' : 'button.cancel') | portalTranslate }}
    </ng-container>
  </button>

  <!-- Save -->
  @if (!closeOnly) {
    <portal-save-button
      [disabled]="disabled"
      [disabledTooltip]="disabledTooltip"
      [invalid]="invalid"
      [pristine]="isPristine"
      [state]="pending || saving"
      (save)="emitSave()"
    >
      <ng-container *portalTransclusion="transclusions; name: 'save'"></ng-container>
    </portal-save-button>
  }
</div>
